import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { Info } from "@livechat/design-system-icons";
import { DesignToken, Heading, Icon, SpacingToken, Tooltip } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  title: string;
  description?: ReactNode;
}

export const EmbeddedSectionHeaderTitle: FC<IProps> = ({ title, description }) => (
  <Wrapper>
    <Heading size="xs">{title}</Heading>
    <Tooltip
      kind="invert"
      triggerRenderer={
        <div
          tabIndex={0}
          aria-haspopup="true"
          role="button"
          aria-label={`About ${title.toLowerCase()}`}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <Icon source={Info} customColor={withVar(DesignToken.ContentBasicSecondary)} />
        </div>
      }
    >
      {description}
    </Tooltip>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing2)};
`;
